import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
export const Width = t0 => {
  const $ = _c(6);
  const {
    children,
    className,
    width
  } = t0;
  const t1 = width ? `${width}%` : undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      maxWidth: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== className || $[4] !== t2) {
    t3 = <div className={className} style={t2}>{children}</div>;
    $[2] = children;
    $[3] = className;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};